// extracted by mini-css-extract-plugin
module.exports = {"button":"ExitCard_button__JyQbc","cutoutBackground":"ExitCard_cutoutBackground__IMACp","buttonLink":"ExitCard_buttonLink__A5j7r"};